import { estadoCivilPessoaFisicaOptions } from "./dynamicTextRegistry";

const showConjugeWhenCasado = {
  field: "ESTADO_CIVIL_PESSOA_FISICA",
  value: "casado",
};

const pessoaFisicaFields = [
  { id: "NOME_PESSOA_FISICA", label: "Nome", type: "text", required: true },
  {
    id: "CPF_PESSOA_FISICA",
    label: "CPF",
    type: "text",
    required: true,
    mask: "cpf",
  },
  { id: "RG_PESSOA_FISICA", label: "RG", type: "text" },
  { id: "NACIONALIDADE_PESSOA_FISICA", label: "Nacionalidade", type: "text" },
  { id: "PROFISSAO_PESSOA_FISICA", label: "Profissao", type: "text" },
  {
    id: "ESTADO_CIVIL_PESSOA_FISICA",
    label: "Estado civil",
    type: "select",
    required: true,
    options: estadoCivilPessoaFisicaOptions,
    placeholder: "Selecione",
  },
  {
    id: "NOME_CONJUGE",
    label: "Nome do conjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "CPF_CONJUGE",
    label: "CPF do conjuge",
    type: "text",
    mask: "cpf",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "RG_CONJUGE",
    label: "RG do conjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "NACIONALIDADE_CONJUGE",
    label: "Nacionalidade do conjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "PROFISSAO_CONJUGE",
    label: "Profissao do conjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "EMAIL_CONJUGE",
    label: "E-mail do conjuge",
    type: "email",
    required: true,
    showWhen: showConjugeWhenCasado,
  },
  { id: "RUA_ENDERECO_PESSOA_FISICA", label: "Rua", type: "text" },
  { id: "N_ENDERECO_PESSOA_FISICA", label: "Numero", type: "text" },
  { id: "BAIRRO_ENDERECO_PESSOA_FISICA", label: "Bairro", type: "text" },
  { id: "MUN_ENDERECO_PESSOA_FISICA", label: "Municipio", type: "text" },
  { id: "CEP_PESSOA_FISICA", label: "CEP", type: "text" },
  { id: "EMAIL_PESSOA_FISICA", label: "Email", type: "email", required: true },
  {
    id: "TEL_PESSOA_FISICA",
    label: "Telefone",
    type: "text",
    mask: "phone",
  },
];

const tipoImovelOptions = {
  casa: [
    { id: "ENDERECO_IMOVEL", label: "Endereco", type: "text" },
    { id: "NUMERO_IMOVEL", label: "Numero", type: "text" },
    { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
    { id: "MUN_IMOVEL", label: "Municipio", type: "text" },
    { id: "AREA_CONSTRUIDA", label: "Area Construida", type: "text" },
    { id: "AREA_TERRENO", label: "Area do Terreno", type: "text" },
    { id: "DESCRICAO_IMOVEL", label: "Descricao do Imovel", type: "text" },
    { id: "MAT_IMOVEL", label: "Matricula", type: "text" },
    { id: "N_CARTORIO", label: "Cartorio", type: "text" },
    { id: "MUN_CARTORIO", label: "Municipio do Cartorio", type: "text" },
  ],
  apartamento: [
    { id: "ANDAR_AP", label: "Andar", type: "text" },
    { id: "VAGA_GARAGEM", label: "Vagas de Garagem", type: "text" },
    { id: "NOME_COND", label: "Condominio", type: "text" },
    { id: "MUN_IMOVEL", label: "Municipio", type: "text" },
    { id: "MAT_IMOVEL", label: "Matricula", type: "text" },
    { id: "N_CARTORIO", label: "Cartorio", type: "text" },
    { id: "MUN_CARTORIO", label: "Municipio do Cartorio", type: "text" },
  ],
  galpao: [
    { id: "ENDERECO_IMOVEL", label: "Endereco", type: "text" },
    { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
    { id: "MUN_IMOVEL", label: "Municipio", type: "text" },
    { id: "UF_IMOVEL", label: "UF", type: "text" },
    { id: "AREA_TOTAL", label: "Area Total (m2)", type: "text" },
    { id: "DESCRICAO_IMOVEL", label: "Descricao do Imovel", type: "text" },
    { id: "MAT_IMOVEL", label: "Matricula", type: "text" },
    { id: "N_CARTORIO", label: "Cartorio", type: "text" },
    { id: "MUN_CARTORIO", label: "Municipio do Cartorio", type: "text" },
  ],
  lote: [
    { id: "ENDERECO_IMOVEL", label: "Endereco", type: "text" },
    { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
    { id: "MUN_IMOVEL", label: "Municipio", type: "text" },
    { id: "UF_IMOVEL", label: "UF", type: "text" },
    { id: "AREA_TOTAL", label: "Area Total (m2)", type: "text" },
    { id: "DESCRICAO_IMOVEL", label: "Descricao do Imovel", type: "text" },
    { id: "MAT_IMOVEL", label: "Matricula", type: "text" },
    { id: "N_CARTORIO", label: "Cartorio", type: "text" },
    { id: "MUN_CARTORIO", label: "Municipio do Cartorio", type: "text" },
  ],
  rural: [
    { id: "LOCALIDADE_IMOVEL", label: "Localidade", type: "text" },
    { id: "MUN_IMOVEL", label: "Municipio", type: "text" },
    { id: "UF_IMOVEL", label: "UF", type: "text" },
    { id: "AREA_TOTAL", label: "Area Total", type: "text" },
    { id: "UNIDADE_AREA", label: "Unidade de Area", type: "text" },
    { id: "DESCRICAO_IMOVEL", label: "Descricao do Imovel", type: "text" },
    { id: "MAT_IMOVEL", label: "Matricula", type: "text" },
    { id: "N_CARTORIO", label: "Cartorio", type: "text" },
    { id: "MUN_CARTORIO", label: "Municipio do Cartorio", type: "text" },
    { id: "CCIR_IMOVEL", label: "CCIR", type: "text" },
  ],
  salacomercial: [
    { id: "ENDERECO_IMOVEL", label: "Endereco", type: "text" },
    { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
    { id: "MUN_IMOVEL", label: "Municipio", type: "text" },
    { id: "UF_IMOVEL", label: "UF", type: "text" },
    { id: "AREA_TOTAL", label: "Area Total (m2)", type: "text" },
    { id: "DESCRICAO_IMOVEL", label: "Descricao do Imovel", type: "text" },
    { id: "MAT_IMOVEL", label: "Matricula", type: "text" },
    { id: "N_CARTORIO", label: "Cartorio", type: "text" },
    { id: "MUN_CARTORIO", label: "Municipio do Cartorio", type: "text" },
  ],
};

const contratoLocacaoImovelFormSchema = [
  {
    sectionId: "locadores",
    sectionLabel: "Locadores",
    repeatable: true,
    groupKey: "locadores",
    minItems: 1,
    fields: [...pessoaFisicaFields],
  },
  {
    sectionId: "locatarios",
    sectionLabel: "Locatarios",
    repeatable: true,
    groupKey: "locatarios",
    minItems: 1,
    fields: [...pessoaFisicaFields],
  },
  {
    sectionId: "testemunhas",
    sectionLabel: "Testemunhas",
    repeatable: true,
    groupKey: "testemunhas",
    fields: [
      { id: "NOME_TESTEMUNHA", label: "Nome", type: "text", required: true },
      {
        id: "CPF_TESTEMUNHA",
        label: "CPF",
        type: "text",
        required: true,
        mask: "cpf",
      },
      { id: "EMAIL_TESTEMUNHA", label: "Email", type: "email", required: true },
    ],
  },
  {
    sectionId: "tipo-imovel",
    sectionLabel: "Tipo de Imovel",
    type: "conditional",
    groupKey: "tipo_imovel",
    requireTypeSelection: true,
    options: tipoImovelOptions,
  },
  {
    sectionId: "uso-locacao",
    sectionLabel: "Uso da Locacao",
    fields: [
      {
        id: "USO_LOCACAO",
        label: "Uso da locacao",
        type: "select",
        required: true,
        options: [
          { value: "comercial", label: "Comercial" },
          { value: "residencial", label: "Residencial" },
          { value: "misto", label: "Misto" },
        ],
        placeholder: "Selecione",
      },
    ],
  },
  {
    sectionId: "clausula-garantia",
    sectionLabel: "Clausula de Garantia",
    type: "conditional",
    groupKey: "clausula_garantia",
    requireTypeSelection: true,
    options: {
      caucao: [
        {
          id: "VALOR_CAUCAO",
          label: "Valor da caucao (R$)",
          type: "text",
          mask: "brl_currency",
          required: true,
        },
        {
          id: "MESES_CAUCAO",
          label: "Meses de caucao",
          type: "number",
          required: true,
        },
      ],
      fiador: [],
    },
  },
  {
    sectionId: "fiadores",
    sectionLabel: "Fiadores",
    repeatable: true,
    groupKey: "fiadores",
    minItems: 1,
    conditionalShow: {
      groupKey: "clausula_garantia",
      type: "fiador",
    },
    fields: [...pessoaFisicaFields],
  },
  {
    sectionId: "dados-financeiros",
    sectionLabel: "Dados Financeiros e Prazos",
    fields: [
      {
        id: "VALOR_ALUGUEL",
        label: "Valor do aluguel (R$)",
        type: "text",
        mask: "brl_currency",
        required: true,
      },
      { id: "DATA_PAGAMENTO", label: "Dia do pagamento", type: "text", required: true },
      {
        id: "MULTA_ATRASO",
        label: "Multa por atraso (%)",
        type: "text",
        mask: "decimal_br",
      },
      {
        id: "MULTA_INFRACAO",
        label: "Multa por infracao (em alugueis)",
        type: "text",
        mask: "decimal_br",
      },
      {
        id: "MULTA_RESCISAO_ANTECIPADA",
        label: "Multa por rescisao antecipada (R$)",
        type: "text",
        mask: "brl_currency",
      },
      { id: "PRAZO_LOCACAO", label: "Prazo da locacao (meses)", type: "number" },
      { id: "DIAS_DESOCUPAR", label: "Dias para desocupacao", type: "number" },
    ],
  },
  {
    sectionId: "dados-gerais",
    sectionLabel: "Dados Gerais",
    fields: [
      { id: "CIDADE_ASSINATURA", label: "Cidade da assinatura", type: "text" },
      { id: "DATA_ASSINATURA", label: "Data da assinatura", type: "date" },
    ],
  },
];

export default contratoLocacaoImovelFormSchema;
